var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"floatButton",staticClass:"float_button",style:({
    width: _vm.itemWidth + 'px',
    height: _vm.itemHeight + 'px',
    left: _vm.left + 'px',
    top: _vm.top + 'px',
  }),attrs:{"draggable":""},on:{"click":_vm.toContact}},[_c('img',{attrs:{"src":require("../assets/img/下载.svg"),"draggable":false}})])
}
var staticRenderFns = []

export { render, staticRenderFns }